import { render, staticRenderFns } from "./NoClientOrBuilder.vue?vue&type=template&id=3f05cddb&"
import script from "./NoClientOrBuilder.vue?vue&type=script&lang=js&"
export * from "./NoClientOrBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports